module.exports = __webpack_public_path__ + "img/certificate2.995592a9.jpg";